/* Kedgo! · FVN · «¿Otro color en su talla?» del carrito (CR2, 2026-10-01).
   <kdg-otro-color> va debajo del último producto agregado (snippets/kdg-otro-color-lugar.liquid). Cuando se ve en
   pantalla pide sections/kdg-otro-color.liquid por la búsqueda y pega los colores. El cajón y la página del carrito
   repintan su contenido al cambiar el carrito, así que el elemento nace de nuevo y vuelve a pedir: no hace falta
   escuchar eventos. Agregar lo hace el formulario nativo del tema que viene en la respuesta. */
(() => {
  if (customElements.get('kdg-otro-color')) return;

  class KdgOtroColor extends HTMLElement {
    connectedCallback() {
      if (this._listo || !this.dataset.q) return;
      this._io = new IntersectionObserver((entradas) => {
        if (!entradas.some((e) => e.isIntersecting)) return;
        this._io.disconnect();
        this.cargar();
      });
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    async cargar() {
      this._listo = true;
      const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = `${raiz}search?q=${encodeURIComponent(this.dataset.q)}&type=product&section_id=kdg-otro-color&kdg=${encodeURIComponent(this.dataset.v || '')}`;
      try {
        const r = await fetch(url, { credentials: 'same-origin' });
        if (!r.ok || !this.isConnected) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const caja = doc.querySelector('.kdg-oc');
        if (!caja) return;
        const max = parseInt(this.dataset.max || '4', 10);
        caja.querySelectorAll('.kdg-oc__it').forEach((el, i) => { if (i >= max) el.remove(); });
        const q = caja.querySelector('.kdg-oc__q');
        if (q) {
          const talla = q.dataset.talla || '';
          const titulo = (this.dataset.titulo || (window.kdgT && window.kdgT.otro_color) || '¿Otro color en talla [talla]?').replace('[talla]', talla);
          const sub = q.dataset.mismo === '1' ? this.dataset.subIgual : this.dataset.sub;
          q.textContent = titulo + ' ';
          if (sub) {
            const s = document.createElement('span');
            s.textContent = sub;
            q.appendChild(s);
          }
        }
        this.replaceChildren(caja);
        this.hidden = false;
      } catch (e) {
        /* sin colores: el módulo queda oculto */
      }
    }
  }

  customElements.define('kdg-otro-color', KdgOtroColor);
})();
